/** @jsx jsx */
import { jsx } from '@compiled/react';
import { Box } from '@atlaskit/primitives/compiled';
import { useIntl } from '@atlassian/jira-intl';
import { PermalinkButton } from '@atlassian/jira-issue-view-common/src/component/permalink-button/button/async.tsx';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';

const CommentCopyLink = () => {
	const { formatMessage } = useIntl();
	const {
		hasFloatingMenu,
		isEditing,
		commentId,
		fullIssueUrl,
		onCopyClick,
		permalink,
		isDeleted,
		isOptimistic,
		isSaving,
	} = useCommentContext();

	if (isDeleted) {
		return null;
	}
	if (isSaving) {
		return null;
	}
	if (isEditing) {
		return null;
	}
	if (hasFloatingMenu) {
		return null;
	}
	if (isOptimistic) {
		return null;
	}

	return (
		<Box testId="issue-comment-base.ui.comment.custom-comment.copy-link">
			<PermalinkButton
				id={commentId}
				fullIssueUrl={`${fullIssueUrl}?focusedCommentId=${commentId}`}
				label={formatMessage(messages.copy)}
				onCopyClick={onCopyClick}
				isVisible={permalink.isVisible}
				isFlush
			/>
		</Box>
	);
};

export default CommentCopyLink;
